"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: dividerRef,
    isVisible: dividerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="2793" id="guwahatiheritagehero" className="relative w-full min-h-screen overflow-hidden bg-background text-foreground">
      {}
      <div className="relative flex flex-col lg:flex-row min-h-screen">
        {}
        <div ref={leftRef} className={`relative w-full lg:w-1/2 min-h-[60vh] lg:min-h-screen bg-background overflow-hidden transition-all duration-1000 ease-out ${leftVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/hotel_revenue_challenge.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/hotel_revenue_challenge.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/hotel_revenue_challenge.png-wvc-sizes" alt="A hotel manager looking at complex revenue data on a laptop screen" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover saturate-50 opacity-80 transition-all duration-[2000ms] ease-out hover:saturate-75 hover:opacity-90" />
          <div className="absolute inset-0 bg-background/30" />

          {}
          <div className="absolute top-8 left-8 lg:top-12 lg:left-12 z-10">
            <div className="flex items-center gap-3">
              <span className="block h-px w-8 bg-foreground/40" />
              <span className="font-default text-xs uppercase tracking-[0.25em] text-foreground/70">
                Revenue · Challenges
              </span>
            </div>
          </div>
        </div>

        {}
        <div ref={rightRef} className={`relative w-full lg:w-1/2 min-h-[60vh] lg:min-h-screen bg-secondary overflow-hidden transition-all duration-1000 ease-out delay-150 ${rightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/hotel_revenue_growth.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/hotel_revenue_growth.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/hotel_revenue_growth.png-wvc-sizes" alt="A modern hotel lobby with gold accents and professional atmosphere" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover transition-transform duration-[3000ms] ease-out hover:scale-105" />
          <div className="absolute inset-0 bg-secondary/10" />

          {}
          <div className="absolute top-8 right-8 lg:top-12 lg:right-12 z-10">
            <div className="flex items-center gap-3">
              <span className="font-default text-xs uppercase tracking-[0.25em] text-secondary-foreground">
                Growth · Strategy
              </span>
              <span className="block h-px w-8 bg-secondary-foreground/60" />
            </div>
          </div>
        </div>

        {}
        <div ref={dividerRef} className="hidden lg:block absolute top-0 bottom-0 left-1/2 -translate-x-1/2 w-px overflow-hidden pointer-events-none z-10">
          <div className={`w-px bg-foreground/30 transition-all duration-[1800ms] ease-out ${dividerVisible ? "h-full" : "h-0"}`} />
        </div>

        {}
        <div ref={headlineRef} className={`absolute inset-0 flex items-center justify-center px-6 lg:px-12 z-20 pointer-events-none transition-all duration-1000 ease-out delay-300 ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="w-full max-w-5xl text-center pointer-events-auto">
            <h1 className="font-default font-bold text-foreground leading-[1.02] tracking-tight text-5xl sm:text-6xl md:text-7xl lg:text-8xl xl:text-9xl">
              Maximize Your Hotel’s Revenue with Data-Driven{" "}
              <em className="italic font-normal" style={{
              color: "var(--secondary)"
            }}>
                Strategies
              </em>
              .
            </h1>

            <p className="mt-8 lg:mt-10 mx-auto max-w-xl text-base md:text-lg font-default text-muted-foreground leading-relaxed">
              Expert revenue management consulting by Sunil Singh. Transform your OTA performance, optimize tech stacks, and drive sustainable growth.
            </p>

            <div className="mt-10 lg:mt-12 flex flex-col sm:flex-row items-center justify-center gap-6">
              <Button asChild size="lg" className="group rounded-lg px-8 py-6 text-base font-medium shadow-md hover:shadow-lg transition-all bg-secondary text-primary-foreground">
                <Link to="/ContactPage">
                  <span>Book a Consultation</span>
                  <ArrowRight className="size-4 transition-transform duration-300 group-hover:translate-x-1" />
                </Link>
              </Button>

              <Link to="/AboutPage" className="group relative inline-flex items-center text-sm font-medium text-foreground">
                <span>Meet Sunil Singh</span>
                <span className="absolute -bottom-1 left-0 h-px w-0 bg-foreground transition-all duration-500 ease-out group-hover:w-full" />
              </Link>
            </div>
          </div>
        </div>
      </div>

      {}
      <div className="lg:hidden absolute left-1/2 top-[60vh] -translate-x-1/2 -translate-y-1/2 w-16 h-px bg-foreground/30 z-10" />
    </section>;
}